//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import round from '~/mixins/round'

export default {
  name: 'BoatReview',
  mixins: [round],
  props: {
    boat: {
      type: Object,
      required: true
    },
    link: {
      type: [Boolean],
      default: true
    }
  },
  computed: {
    getReviewValue() {
      return this.boat.average_rating || parseFloat(this.boat.rating)
    },
    getReviewCount() {
      return this.boat.review_count || parseInt(this.boat.reviewCount, 10)
    },
    getReviewValueText() {
      return this.getTextByRating(this.getReviewValue)
    }
  },
  methods: {
    getTextByRating(value) {
      if (value < 2) {
        return this.$t('rating-text-more-than-1')
      } else if (value < 3.5) {
        return this.$t('rating-text-more-than-2')
      } else if (value < 4) {
        return this.$t('rating-text-more-than-3')
      } else if (value < 4.5) {
        return this.$t('rating-text-more-than-4')
      } else if (value >= 4.5) {
        return this.$t('rating-text-more-than-5')
      }
    }
  }
}
